export default "__VITE_ASSET__BYuo5m12__"